import React, { useState } from "react";
import { CallsDataContainer, PageWrapper } from "../../containers";

export const CallsData = () => {
  const [isLoading, setIsLoading] = useState(false);

  return <PageWrapper loading={isLoading} pageContainerChildren={<CallsDataContainer />} />;
};

export default CallsData;
